import React from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { ArcaAfipWizardPanel } from "@/components/arca/ArcaAfipWizardPanel";

/**
 * Submódulo Opciones: configuración fiscal persistente (no es pantalla de ventas).
 */
export function ArcaAfipSection() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>ARCA / AFIP</CardTitle>
        <CardDescription>
          Certificados, entorno (test/producción), punto de venta fiscal y pruebas de conectividad. La emisión de
          comprobantes sigue el flujo existente en Ventas; acá solo se administra la configuración que consume el
          servicio fiscal.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <ArcaAfipWizardPanel variant="opciones" />
      </CardContent>
    </Card>
  );
}
